const PORTAL_VIEWER_KEY = 'meridian.portal-viewer';

// The customer route is anonymous and bypasses the portal's forward auth, so the API cannot tell a
// rep previewing their own link from the buyer. A browser that has ever completed a portal sign-in
// carries this marker, and engagement from it is flagged internal rather than dropped.
export function markPortalViewer(): void {
  try {
    localStorage.setItem(PORTAL_VIEWER_KEY, String(Date.now()));
  } catch {
    // storage blocked: the visit is simply not flagged
  }
}

export function hasPortalViewerMarker(): boolean {
  try {
    return localStorage.getItem(PORTAL_VIEWER_KEY) !== null;
  } catch {
    return false;
  }
}
